import { api } from "./apiClient";

export const dashboardAPI = {
  getAdminGlobal: () => api.get("/admin/dashboard"),
};
